export function SOQUIJSVG() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='75'
			zoomAndPan='magnify'
			viewBox='0 0 240 239.999995'
			height='75'
			preserveAspectRatio='xMidYMid meet'
			version='1.0'
		>
			<path
				fill='#a6a6a6'
				d='M 120.066406 240 C 109.101562 240 100.101562 231 100.101562 220.035156 L 100.101562 154.375 L 43.300781 187.277344 C 33.882812 192.757812 21.648438 189.386719 16.167969 179.964844 C 10.683594 170.402344 13.917969 158.3125 23.617188 152.828125 L 80.417969 120.070312 L 23.617188 87.03125 C 19.117188 84.359375 15.746094 80.28125 14.339844 74.9375 C 13.074219 69.878906 13.777344 64.394531 16.308594 59.894531 C 18.835938 55.394531 23.195312 52.160156 28.398438 50.753906 C 33.460938 49.351562 38.941406 50.191406 43.441406 52.722656 L 100.242188 85.484375 L 100.242188 19.964844 C 100.242188 9 109.101562 0 120.066406 0 C 130.894531 0 139.890625 9 139.890625 19.964844 L 139.890625 85.765625 L 196.976562 52.722656 C 201.472656 50.050781 206.816406 49.351562 212.019531 50.753906 C 217.082031 52.160156 221.296875 55.394531 224.109375 59.894531 C 226.78125 64.394531 227.34375 69.878906 226.078125 74.9375 C 224.671875 80 221.296875 84.359375 216.800781 87.03125 L 159.855469 119.929688 L 216.660156 152.6875 C 226.21875 158.171875 229.3125 170.261719 223.828125 179.824219 C 221.15625 184.324219 217.082031 187.699219 211.738281 188.964844 C 206.675781 190.367188 201.191406 189.527344 196.695312 186.996094 L 139.890625 154.375 L 139.890625 220.175781 C 139.890625 231 130.894531 240 120.066406 240 Z M 120.066406 240 '
				fillOpacity='1'
				fillRule='evenodd'
			/>
		</svg>
	);
}
